<template>
    <div class="common">
        <a-tabs type="card" v-model="tabCur">
            <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
                <keep-alive v-if="tabCur == item.key">
                    <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
                </keep-alive>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import guaranteeMain from "@/pages/review/guarantee/guarantee-main"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
    components: {
        guaranteeMain
    },
    name: "guarantee",
    data() {
        return {
            tabData: [
                {
                    name: "待复核",
                    key: "review",
                    comp: guaranteeMain,
                    status: "1",
                },
                {
                    name: "复核记录",
                    key: "records",
                    comp: guaranteeMain,
                    status: "2,3"
                }
            ],
            tabCur: "review"
        }
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj"

        })
    },
    created() {
    },
    mounted() {

    },
    methods: {


    },
    activated() {

    },
};
</script>
<style scoped lang="less">
.common {
    /deep/ .ant-tabs-tab-active {
        border-bottom: 1px solid #e8e8e8 !important;
    }

    /deep/ .ant-tabs-bar {
        border-bottom: none !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/review/guarantee/guarantee.vue